<template>
  <div class="banner-image-area position-relative my-5">
    <div class="container_fl">
      <div class="row align-items-center">
        <div class="col-lg-6 order-1 order-lg-1 wow move-up text-right p-5">
          <div class="banner-image__media pl-3">
            <img src="../assets/img/illustrations/contact_us.svg" class="img-fluid" />
          </div>
        </div>
        <div class="col-lg-6 order-2 order-lg-2 wow move-up p-5">
          <div class="banner-image__content">
            <div class="section-title-wrapper mb-20">
              <h2 class="section-title font-weight--light">Contact us</h2>
            </div>
            <b-form v-if="!success">
              <b-form-input
                class="mb-4"
                id="contact-email"
                v-model="form.email"
                type="email"
                required
                placeholder="Email"
              />
              <b-form-textarea
                class="mb-4"
                id="contact-message"
                v-model="form.message"
                placeholder="Your message"
                rows="6"
                max-rows="6"
              />
              <p style="color: #c26bbb;" v-show="error">{{ msg }}</p>
              <b-button @click="onSubmit">Send</b-button>
            </b-form>
            <h5 v-if="success" style="color: #c26bbb;" class="font-weight--light">{{ msg }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
export default {
  name: "BannerOne",
  data() {
    return {
      form: {
        email: "",
        message: "",
        added: new Date(),
      },
      success: false,
      error: false,
      msg: "",
    };
  },
  methods: {
    onSubmit() {
      this.success = false;
      this.error = false;
      if (this.form.email && this.form.message) {
        this.addMessage();
      } else {
        this.error = true;
        this.msg =
          "You need to add a valid email and a message for us to look at";
      }
    },
    addMessage() {
      return firebase
        .firestore()
        .collection("messages")
        .add(this.form)
        .then(() => {
          this.success = true;
          this.msg =
            "Your message has been sent, we'll get back to you in a jiffy!";
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
          this.msg = "Oops, something went wrong, please try again";
        });
    },
  },
};
</script>